<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <h2>
                    <span class="btn btn-default fa fa-arrow-left" aria-hidden="true" @click="goBack()"
                          :title="translations.lbl_clients"></span>
                    {{ translations.lbl_client}}: {{ client.clientName }}
                </h2>
            </div>
        </div>
        <ul class="nav nav-tabs">
            <li role="presentation" :class="{ active: isTabActive['tab1'] }">
                <a href="#" @click.prevent="setActiveTab('tab1')">
                    {{ getTranslation('lbl_tab_dashboard') }}
                </a>
            </li>
            <li role="presentation" :class="{ active: isTabActive['tab2'] }">
                <a href="#" @click.prevent="setActiveTab('tab2')">
                    {{ getTranslation('lbl_tab_management') }}
                </a>
            </li>
            <li :class="{ active: isTabActive['tab3'] }">
                <a href="#" @click.prevent="setActiveTab('tab3')">
                    {{ getTranslation('menu_main_user_list') }}
                </a>
            </li>
            <li :class="{ active: isTabActive['tab4'] }" v-if="client.useCustomers">
                <a href="#" @click.prevent="setActiveTab('tab4')">
                    {{ getTranslation('menu_main_customer_list') }}
                </a>
            </li>
        </ul>
        <template v-if="isTabActive['tab4']">
            <div class="col-sm-12">
                <div class="panel panel-default">
                    <customer-block v-if="customerDisplay" :client="client" :isClientSubPage="true"></customer-block>
                </div>
            </div>
        </template>
        <template v-if="isTabActive['tab3']">
            <user-list :client="client" :hideTitle="true" :isClientSubPage="true"></user-list>
        </template>
        <template v-if="isTabActive['tab2']">
            <div class="row" >
                <div class="col-sm-12">
                    <div class="panel panel-default">
                        <client-edit-block :hideTitle="true"></client-edit-block>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="isTabActive['tab1']">
            <div class="row">
                <div class="col-sm-12">
                    <div class="panel panel-default">
                        <timeplan-block v-if="timeplanDisplay" :client="client"></timeplan-block>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="panel panel-default">
                        <contacts-block v-if="contactsDisplay" :client="client"></contacts-block>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="panel panel-default">
                        <tickets-block v-if="ticketsDisplay" :client="client"></tickets-block>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js';
    import { dropdownMixin } from '../../../../Banet/mixins/dropdownMixin.js';
    import { mixin as clickaway } from 'vue-clickaway';
    import Contacts from '../../../protected/components/contacts/Contacts.vue';
    import Tickets from '../../../protected/components/tickets/Tickets.vue';
//    import Timeplan from '../../../protected/components/atimeplan/Atimeplan.vue';
    import Timeplan from '../../../protected/components/timeplan/Timeplan.vue';
    import ClientEdit from '../../../protected/components/clients/ClientEdit.vue';
    import UserList from '../user/UserList.vue';
    import CustomerList from "../../../protected/components/customer/CustomerList.vue";

    export default {
        mixins: [ translationMixin, dropdownMixin, clickaway ],
        components: {
            customerBlock: CustomerList,
            contactsBlock: Contacts,
            ticketsBlock: Tickets,
            timeplanBlock: Timeplan,
            clientEditBlock: ClientEdit,
            userList: UserList
        },
        created: function(){
            const id = this.$route.params.id;
            this.$socket.emit('getClient', id);
        },
        sockets:{
            clientData: function(client){
                if(!client || typeof client === "undefined") { return; }
                this.client = client;
                this.contactsDisplay = true;
                this.ticketsDisplay = true;
                this.timeplanDisplay = true;
                this.customerDisplay = true;

                if(this.client.language) {
                    this.setLanguage(this.client.language);
                }

                if (this.fromClientAdmin) {
                    this.setActiveTab('tab3');
                    this.fromClientAdmin = false;
                }
                if (this.activeTab) {
                   const tab = 'tab' + this.activeTab;
                   this.setActiveTab(tab);
                   this.activeTab = 0;
                }
            },
            clientChanged: function(){
//                this.$router.push('/clients');
               this.$socket.emit('getClient', this.client._id);
            }
        },
        data: function () {
            return {
               tabActive: {
                  tab1: true,
                  tab2: false,
                   tab3: false
               },
                client: {},
                cLangString: 'English',
                contactsDisplay: false,
                ticketsDisplay: false,
                timeplanDisplay: false,
                audioStatus: [ false, false, false, false, false, false, false ],
                audioPlayingIndex: '',
                fromClientAdmin: false,
               activeTab: 0
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {

                if (from.meta.isClientAdmin) {
                    vm.fromClientAdmin = true;
                }
                if(from.meta.activeTab){
                   vm.activeTab = from.meta.activeTab;
                }

            });
        },
        computed: {
            serverURL: function() {
                return mainEventBus.serverURL;
            },
            rootPath: function(){
                return mainEventBus.$data.serverURL;
            },
            filePath: function(){
                var path = '';
                if(this.client.clientApiToken){
                    path = this.rootPath + '/api/twilio/' + this.client.clientApiToken + '/';
                }
                return path;
            },
           isTabActive: function(){
              return this.tabActive;
           }
        },
        methods: {
           setActiveTab: function(tab){
              for (var i in this.tabActive){
                 this.tabActive[i] = false;
              }
              this.tabActive[tab] = true;
           },
            addClient: function(){
                for (var i in this.client) {
                    if(!this.client[i]) {
                        mainEventBus.$emit( 'alert', { type:'warning', msg:'warning_lbl_all_required' } );
                        return false;
                    }
                }
                this.$socket.emit('clientCreate', this.client);
            },
            setLanguage: function(lang){
                this.client.language = lang;
                if(lang == 'en'){
                    this.cLangString =  'English'
                } else if (lang == 'de') {
                    this.cLangString =  'Deutsch';
                }
            },
            goBack: function(){
                this.$router.push('/clients');
            },
            goEdit: function(){
                this.$router.push('/client/edit/' + this.client._id);
            },
            playRecord: function(index){
                var refKeys = Object.keys(this.$refs);
                var numIndex = parseInt(index.split('audioPreview')[1]);

                for (var i = 0; i < refKeys.length; i++) {
                    if (refKeys[i].indexOf('audioPreview') >= 0) {
                        if (refKeys[i] != index || this.isPlaying(index))
                            this.stopRecord(refKeys[i]);
                        else {
                            this.$refs[index].play();
                            this.audioStatus[numIndex] = true;
                        }
                    }
                }

                if (this.audioStatus[numIndex])
                    this.audioPlayingIndex = index;
            },
            stopRecord: function(index) {
                this.$refs[index].pause();
                this.$refs[index].currentTime = 0;
                this.audioStatus[parseInt(index.split('audioPreview')[1])] = false;
                this.audioPlayingIndex = '';
            },
            isPlaying: function(index) {
                return !this.$refs[index].paused && this.$refs[index].currentTime > 0 && !this.$refs[index].ended;
            },
            audioPreviewClass: function(index) {
                if (this.audioPlayingIndex != index)
                    return 'fa-play';
                else
                    return 'fa-stop';
            }
        }
    }
</script>


<style scoped>
    .dropdown {
        width: 100%;
    }
    .dropdown .caret {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .dropdown .dropdown-toggle {
        width: 100%;
        text-align: left;
    }

    .dropdown-menu {
        width: 100%;
        margin-top: -1px;
    }
</style>


// WEBPACK FOOTER //
// Client.vue?dad8bed4